// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Loading from '../components/Loading';
import { useIdpInfo } from '../contexts/IdpContext';
import { useUserState } from '../contexts/UserContext';
import { useConfig } from '../hooks/other/useConfig';
import { LoginPageLayout } from '../layout/LoginPageLayout';
import { DappLogin } from './DappLogin';
import { NonDappLogin } from './NonDappLogin';

export const Login: React.FC = () => {
  const { isLoading, loggedInUser } = useUserState();
  const config = useConfig();
  const { isLoading: idpInfoLoading } = useIdpInfo();
  const nav = useNavigate();

  useEffect(() => {
    if (!isLoading && loggedInUser) {
      nav('/', { replace: true });
    }
  }, [loggedInUser, isLoading, nav]);
  if (idpInfoLoading || isLoading) {
    return <Loading />;
  }
  if (config.app.enableDappLogin) {
    return <DappLogin />;
  }

  return (
    <LoginPageLayout>
      <NonDappLogin />
    </LoginPageLayout>
  );
};
